import { render } from "./RfRegion.vue?vue&type=template&id=b064f920"
import script from "./RfRegion.vue?vue&type=script&lang=js"
export * from "./RfRegion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__